import { Link } from "react-router-dom"
import { LoversLiveForeverLogo } from "./LoversLiveForeverLogo"

export const WithSimpleLogoHeader = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen">
    <header className="absolute top-0 left-0 right-0 flex justify-center">
      <nav aria-label="Global" className="py-4">
        <Link to="/">
          <span className="sr-only">Lovers live forever</span>
          <LoversLiveForeverLogo className="h-20 w-auto" />
        </Link>
      </nav>
    </header>
    <div className="min-h-screen flex items-center justify-center">{children}</div>
  </div>
)
